
import { useState } from 'react';
import BookingChoiceModal from '../../../components/feature/BookingChoiceModal';

const HeroSection: React.FC = () => {
  const [showBookingChoice, setShowBookingChoice] = useState(false);

  return (
    <>
      <section 
        className="relative min-h-screen flex items-center bg-cover bg-center bg-no-repeat pt-20 sm:pt-24 pb-12 sm:pb-20 px-4"
        style={{
          backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.6), rgba(0, 0, 0, 0.5)), url('https://static.readdy.ai/image/c82a80d6d696663c2db3260ddbcff61b/1372d4f25c2f636f63a0df071af89e47.png')`
        }}
      >
        <div className="w-full max-w-7xl mx-auto text-center">
          <div className="max-w-5xl mx-auto">
            <h1 className="text-4xl sm:text-5xl md:text-6xl lg:text-7xl xl:text-8xl font-bold text-white mb-4 sm:mb-6 leading-tight px-2">
              Transform Your Outdoor Space Today
            </h1>
            
            <p className="text-xl sm:text-2xl md:text-3xl lg:text-4xl text-[#83B328] mb-4 sm:mb-6 font-semibold px-2">
              Professional Landscaping Services in Harford County, MD
            </p>

            <p className="text-base sm:text-lg md:text-xl lg:text-2xl text-white mb-6 sm:mb-8 lg:mb-10 max-w-3xl mx-auto px-2">
              From mulching to custom designs, we deliver 5-star results with 9+ years of trusted experience
            </p>

            <button 
              onClick={() => setShowBookingChoice(true)}
              className="inline-block bg-[#83B328] text-white px-8 sm:px-10 lg:px-12 py-4 sm:py-5 lg:py-6 rounded-lg text-lg sm:text-xl lg:text-2xl font-bold hover:bg-[#6d9620] transition-colors whitespace-nowrap cursor-pointer shadow-2xl mb-8 sm:mb-10 lg:mb-12"
            >
              Book Now
            </button>

            <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 sm:gap-6 lg:gap-8 max-w-4xl mx-auto">
              <div className="bg-white/10 backdrop-blur-sm rounded-lg p-4 sm:p-5 lg:p-6 border border-white/20">
                <div className="w-12 h-12 sm:w-14 sm:h-14 lg:w-16 lg:h-16 bg-[#83B328] rounded-full flex items-center justify-center mx-auto mb-3 sm:mb-4">
                  <i className="ri-shield-check-line text-2xl sm:text-2xl lg:text-3xl text-white"></i>
                </div>
                <h3 className="text-base sm:text-lg font-bold text-white mb-1 sm:mb-2">Licensed & Insured</h3>
                <p className="text-gray-200 text-xs sm:text-sm">Fully licensed and insured for your peace of mind</p>
              </div>
              
              <div className="bg-white/10 backdrop-blur-sm rounded-lg p-4 sm:p-5 lg:p-6 border border-white/20">
                <div className="w-12 h-12 sm:w-14 sm:h-14 lg:w-16 lg:h-16 bg-[#83B328] rounded-full flex items-center justify-center mx-auto mb-3 sm:mb-4">
                  <i className="ri-star-fill text-2xl sm:text-2xl lg:text-3xl text-white"></i>
                </div>
                <h3 className="text-base sm:text-lg font-bold text-white mb-1 sm:mb-2">5-Star Service</h3>
                <p className="text-gray-200 text-xs sm:text-sm">Consistently rated 5 stars by our customers</p>
              </div>
              
              <div className="bg-white/10 backdrop-blur-sm rounded-lg p-4 sm:p-5 lg:p-6 border border-white/20">
                <div className="w-12 h-12 sm:w-14 sm:h-14 lg:w-16 lg:h-16 bg-[#83B328] rounded-full flex items-center justify-center mx-auto mb-3 sm:mb-4">
                  <i className="ri-time-line text-2xl sm:text-2xl lg:text-3xl text-white"></i>
                </div>
                <h3 className="text-base sm:text-lg font-bold text-white mb-1 sm:mb-2">9+ Years Experience</h3>
                <p className="text-gray-200 text-xs sm:text-sm">Nearly a decade of professional landscaping</p>
              </div>
            </div>

          </div>
        </div>
      </section>

      <BookingChoiceModal isOpen={showBookingChoice} onClose={() => setShowBookingChoice(false)} />
    </>
  );
};

export default HeroSection;
